
import init from './app/init';

const app = {
	init
};

if (window.__app__)
	Object.assign(window.__app__, app);
else
	window.__app__ = app;

export default app;